import _ from 'underscore';

//加快webpack热更新（潘磊找的方法）
//第一步：get_routes_by_require不在./src/router/index.js时调用
const get_routes_by_require = function () {
  const require_route = require.context(
    // 其组件目录的相对路径
    '@/page',
    // 是否查询其子目录
    true,
    // 匹配基础组件文件名的正则表达式
    /\/route\.js$/
  );
  const __routes = _.chain(require_route.keys())
    .map(function (m) {
      const __path = m;
      const route = require_route(__path);
      return route.default;
    })
    .value()
  ;
  return __routes
};
export default get_routes_by_require;
